var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSidebarChevronLeft = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 25,
  fill: "none",
  viewBox: "0 0 25 25",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 24.107,
  height: 24.107,
  x: 0.446,
  y: 0.446,
  fill: "#161A23",
  rx: 6.696
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 24.107,
  height: 24.107,
  x: 0.446,
  y: 0.446,
  stroke: "#2D2F39",
  strokeWidth: 0.893,
  rx: 6.696
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.8,
  d: "M14.707 9.35a.595.595 0 1 0-.842-.842l-3.572 3.571a.595.595 0 0 0 0 .842l3.572 3.571a.595.595 0 1 0 .841-.842l-3.15-3.15z"
})));
export { SvgSidebarChevronLeft as ReactComponent };
export default __webpack_public_path__ + "assets/images/sidebarChevronLeft.svg";